import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['crm'], // 为了获取基础路由
    };
};
export const crmToPathNameMap = {
    crm1010: ({ businessKey }) => commonFunc(`/customer/file/detail?id=${businessKey}`),
    crm1020: ({ businessKey }) => commonFunc(`/business/manager/detail?id=${businessKey}`),
    crm1030: ({ businessKey }) => commonFunc(`/home?taskid=${businessKey}`),
    crm1040: ({ businessKey }) => commonFunc(`/home?taskid=${businessKey}`),
    crm1210: ({ businessKey }) => commonFunc(`/filing/detail?id=${businessKey}`),
    crm1220: ({ businessKey }) => commonFunc(`/business/filing/detail?id=${businessKey}`),
    crm2020: ({ businessKey }) => commonFunc(`/clues-my/-detail?id=${businessKey}`),
    crm2040: ({ businessKey }) => commonFunc(`/project-prepare/detail?id=${businessKey}`),
    riskWarning1030_crm1040_1: ({ businessKey }) => commonFunc(`/risk/log-search/detail?id=${businessKey}`),
    riskWarning1030_crm1040_2: ({ businessKey }) => commonFunc(`/risk/log-search/detail?id=${businessKey}`),
    riskWarning1030_crm1040_3: ({ businessKey }) => commonFunc(`/risk/log-search/detail?id=${businessKey}`),
    riskWarning1030_crm1040_4: ({ businessKey }) => commonFunc(`/risk/log-search/detail?id=${businessKey}`),
};
